import { createContext, useReducer } from 'react'
import { type NavigationProviderProps, type NavigationDataContextProps, type NavigationDispatchContextProps } from 'src/types'

import { reducer } from './reducer'
import { defaultNavigation } from './defaults'

export const NavigationDataContext = createContext<NavigationDataContextProps>({ navigation: defaultNavigation })
NavigationDataContext.displayName = 'NavigationDataContext'

export const NavigationDispatchContext = createContext<NavigationDispatchContextProps>({ dispatchNavigation: () => null })
NavigationDispatchContext.displayName = 'NavigationDispatchContext'

export const NavigationProvider = ({ children }: NavigationProviderProps) => {
  const [navigation, dispatchNavigation] = useReducer(reducer, defaultNavigation)
  
  return (
    <NavigationDataContext.Provider value={{ navigation }}>
      <NavigationDispatchContext.Provider value={{ dispatchNavigation }}>
        {children}
      </NavigationDispatchContext.Provider>
    </NavigationDataContext.Provider>
  )
}
